import React, { useState } from "react";
import GuideSection from "../../components/guide/GuideSection";
import { adminGuide } from "../../components/guide/guideContent";
import Header from "../../components/header/Header";
import ProgressBar from "../../components/progressBar/ProgressBar";
import { FaArrowRight } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addToCart } from "../../redux/actions/CartActions";
import pricing from "../../assets/data/pricing.json";
import { Col, Image, Row } from "react-bootstrap";
import { addToServiceList } from "../../redux/actions/ServiceListActions";
import serviceCode from "../../assets/data/serviceCode.json";
import {
  updateAdminRequest,
  updateBusinessRequest,
  updateDomiciliationRequest,
  updateGrhRequest,
  updateJuridiqueRequest,
  updateManagementRequest,
  updateSalesRequest,
} from "../../redux/actions/RequestActions";
import Swal from "sweetalert2";
import Loader from "../../components/loader/Loader";

function EditPlatformAdmin() {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState("mensuel");
  const currentStep = "Services";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const turnover = cart.turnover || 0;
  const { user } = useSelector((state) => state.authUser);
  const {
    businessCreationRequest,
    domiciliationRequest,
    managementRequest,
    juridiqueRequest,
    adminRequest,
    grhRequest,
    salesRequest,
  } = useSelector((state) => state.request);
  const [submitting, setSubmitting] = useState(false);
  const servicesList = useSelector((state) => state.serviceList.services);

  const handleButtonClick = async () => {
    setSubmitting(true);

    let updatedServices = [...servicesList];
    // Vérifie si un élément avec le même code existe déjà
    const existingIndex = updatedServices.findIndex(
      (service) => service.code === serviceCode.platformAdmin,
    );

    const newService = {
      code: serviceCode.platformAdmin,
      billing: selectedPlan === "annuel" ? "yearly" : "monthly",
    };

    if (existingIndex !== -1) {
      // Remplace l'élément existant
      updatedServices[existingIndex] = newService;
    } else {
      // Sinon, ajoute le nouvel élément
      updatedServices.push(newService);
    }

    if (cart.from === "creation") {
      await dispatch(
        updateBusinessRequest(
          user.token,
          businessCreationRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "domiciliation") {
      await dispatch(
        updateDomiciliationRequest(
          user.token,
          domiciliationRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "management") {
      await dispatch(
        updateManagementRequest(
          user.token,
          managementRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "admin") {
      await dispatch(
        updateAdminRequest(
          user.token,
          adminRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "juridique") {
      await dispatch(
        updateJuridiqueRequest(
          user.token,
          juridiqueRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "grh") {
      await dispatch(
        updateGrhRequest(
          user.token,
          grhRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    } else if (cart.from === "sales") {
      await dispatch(
        updateSalesRequest(
          user.token,
          salesRequest.reference,
          {
            services: [...updatedServices],
          },
          handleCallback,
        ),
      );
    }
  };

  const handleCallback = async ({ success, message }) => {
    const amount =
      selectedPlan === "annuel"
        ? turnover < 50000000
          ? pricing.platformAdmin.annuel
          : pricing.platformAdmin.annuel * 1.8
        : turnover < 50000000
          ? pricing.platformAdmin.mensuel
          : pricing.platformAdmin.mensuel * 1.8;
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      await dispatch(
        addToCart({
          platformAdmin: {
            periodicity: selectedPlan,
            amount: amount,
          },
        }),
      );

      await dispatch(
        addToServiceList({
          code: serviceCode.platformAdmin,
          billing: selectedPlan === "annuel" ? "yearly" : "monthly",
        }),
      );

      navigate(-1, { replace: true });
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  const handleSkipClick = () => {
    navigate(-1, { replace: true });
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />
      <Loader isLoading={submitting} />

      <div
        className="container mt-4 mb-4 text-center"
        style={{ maxWidth: "900px" }}
      >
        <h4 className="text-2xl font-semibold">
          Une gestion <span style={{ color: "#FF5500" }}>administrative</span>{" "}
          et <span style={{ color: "#FF5500" }}>fiscale</span> simplifiée avec
          <span style={{ color: "#FF5500" }}> PlatformAdmin</span>
        </h4>
      </div>

      <div className="container mb-3">
        <Row>
          {/* <Col md={3} className="mb-3">
                       <Image
                         src="/images/administration/tax_accounting_tracking.webp"
                         alt="About"
                         fluid
                         className="d-block mx-auto"
                         height={200}
                         width={200}
                         style={{ borderRadius: 16 }}
                       />
                       <div style={{ fontSize: "16px", fontWeight: "500" }}>
                         Suivi comptabilité générale
                       </div>
                     </Col> */}
          <Col md={4} className="mb-3">
            <Image
              src="/images/administration/monthly_e_filing.webp"
              alt="About"
              fluid
              className="d-block mx-auto"
              height={200}
              width={200}
              style={{ borderRadius: 16 }}
            />
            <div style={{ fontSize: "16px", fontWeight: "500" }}>
              Télé déclaration Mensuelle
            </div>
          </Col>

          <Col md={4} className="mb-3">
            <Image
              src="/images/administration/tax_optimization.webp"
              alt="About"
              fluid
              className="d-block mx-auto"
              height={200}
              width={200}
              style={{ borderRadius: 16 }}
            />
            <div style={{ fontSize: "16px", fontWeight: "500" }}>
              Déclaration statistique et fiscale (DSF)
            </div>
          </Col>

          <Col md={4} className="mb-3">
            <Image
              src="/images/administration/CNPS.webp"
              alt="About"
              fluid
              className="d-block mx-auto"
              height={200}
              width={200}
              style={{ borderRadius: 16 }}
            />
            <div style={{ fontSize: "16px", fontWeight: "500" }}>
              Cotisation sociale
            </div>
          </Col>
        </Row>
      </div>

      <div className="container  text-center">
        <h5 className="mb-3">Choisissez votre abonnement</h5>
        <div className="d-flex justify-content-center gap-4">
          <label style={{ cursor: "pointer" }}>
            <input
              type="radio"
              name="plan"
              value="mensuel"
              checked={selectedPlan === "mensuel"}
              onChange={() => setSelectedPlan("mensuel")}
              className="me-2"
            />
            <span className="font-bold" style={{ color: "#3392FF" }}>
              {turnover < 50000000
                ? pricing.platformAdmin.mensuel
                : pricing.platformAdmin.mensuel * 1.8}{" "}
              XAF / mois (abonnement mensuel)
            </span>
          </label>

          <label style={{ cursor: "pointer" }}>
            <input
              type="radio"
              name="plan"
              value="annuel"
              checked={selectedPlan === "annuel"}
              onChange={() => setSelectedPlan("annuel")}
              className="me-2"
            />
            <span className="font-bold" style={{ color: "#3392FF" }}>
              {turnover < 50000000
                ? pricing.platformAdmin.annuel
                : pricing.platformAdmin.annuel * 1.8}{" "}
              XAF / mois (abonnement annuel)
            </span>
          </label>
        </div>
      </div>

      <div className="container text-center mt-4">
        <button
          className="btn"
          style={{
            backgroundColor: "#051259",
            color: "#fff",
            borderRadius: "50px",
            padding: "10px 20px",
          }}
          onClick={handleButtonClick}
        >
          Obtenir ce service
          <FaArrowRight style={{ marginLeft: "8px" }} />
        </button>
      </div>

      <div className="container text-center mt-3">
        <span
          onClick={handleSkipClick}
          style={{ color: "#3392FF", cursor: "pointer" }}
        >
          Retour
        </span>
      </div>

      <GuideSection {...adminGuide} />
    </div>
  );
}

export default EditPlatformAdmin;
